import { JWebPromise, PluginRegistry, WhenJWebReady } from '@jarvis/jweb-core';

const getPlugins = async (): Promise<PluginRegistry> => {
  const response: JWebPromise = await WhenJWebReady;

  if (!response) {
    console.error('getPlugins: JWeb not ready');
    throw new Error('JWeb is not ready');
  }

  return response.Plugins;
};

export default getPlugins;
